import { render } from "./ModalCard.vue?vue&type=template&id=02e584f6"
import script from "./ModalCard.vue?vue&type=script&lang=js"
export * from "./ModalCard.vue?vue&type=script&lang=js"
script.render = render

export default script